import { OmniaModuleId } from "../generated/enums"
import { omniaDefer, OmniaDefer, OmniaPromise } from "../promises"
import { ClientActivity } from "../shell"
import { IModule } from "../shell/types"
import { ExternalModuleContext } from "../types"

export interface ReactOmniaModule extends IModule {

    setActivity(activity: ClientActivity): () => void
    suspendRefresh(): () => void

    disableShell(disable: boolean): () => void
    blockUi(block: boolean | string): void

}

interface CreateArgs {
    moduleId: OmniaModuleId
    moduleName: string
    helpSection?: string
    context: ExternalModuleContext
    refresh: (auto: boolean) => OmniaPromise<any>
}

export function createReactOmniaModule({ moduleId, moduleName, helpSection, context, refresh }: CreateArgs): ReactOmniaModule {

    const a = {

        moduleId,
        moduleName,
        helpSection,

        getCurrentFilter: () => undefined,
        getCurrentComponent: () => undefined,

        disableShell: (disable: boolean) => context.disableShell(disable),
        blockUi: (block: boolean | string) => context.blockUi(block),

    }

    const b = withActivity(a, context)

    const c = withRefresh(b, refresh)

    return c


}

function withActivity<T>(module: T, context: ExternalModuleContext) {

    let activity: ClientActivity

    return {

        ...module,

        getCurrentActivity: () => activity,

        setActivity(a: ClientActivity) {

            const b = activity
            activity = a

            context.apply()

            return () => {
                activity = b
            }

        }

    }
}

/**
 * Add refresh-related features (refresh, canRefresh, and suspendRefresh)
 *
 * @param target Target
 * @param context Context for external module
 * @param refresh Refresh method
 */
function withRefresh<T>(target: T, refresh: (auto: boolean) => OmniaPromise<any>) {

    let suspended: OmniaDefer<any>
    let promise: OmniaPromise<any>

    return {

        ...target,

        canRefresh: () => !suspended,

        get enableAutoRefresh() {
            return !suspended
        },

        /**
         * Returns a promise which can be used to refresh to module
         * If refreshes are not suspend, simply returns the promise provided by the base refresh argument
         * If they are, defers actually refreshes until "suspended" is resolved
         */
        refresh(auto: boolean) {

            if (suspended) {
                return (promise = promise || suspended.promise.then(refresh))
            }

            return refresh(auto)

        },

        /**
         * Suspends refreshes, and returns a function which can be called to enabled them again
         * If refreshes are already suspended, this does nothing
         * If they are not, initializes the "suspended" deferred, and returns a function which will resolve it,
         * and cleanup
         */
        suspendRefresh() {

            if (suspended) {
                return () => { }
            }

            suspended = omniaDefer()

            return () => {
                suspended?.resolve()
                suspended = undefined
                promise = undefined
            }

        }

    }

}

